//用户管理
import http from '../jslibs/axios/http';

// 企业列表
export const getBusinessList = data => http.get('/cms/Business', data);
// 新增企业
export const addBusiness = data => http.post('/cms/Business', data);
//编辑企业
export const updateBusiness = data => http.put('/cms/Business/' + data.uuid, data);
//企业详情
export const getBusinessDetail = data => http.get('/cms/Business/' + data.uuid);
//删除企业
export const deleteBusiness = data => http.delete('/cms/Business/' + data.uuid);

//用户列表
export const getUserList = data => http.get('/cms/User', data);
//删除用户
export const deleteUser = data => http.delete('/cms/User/' + data.uuid);
// 添加用户
export const addUser = data => http.post('/cms/User', data);
//编辑用户
export const updateUser = data => http.put('/cms/User/' + data.uuid, data);
//用户详情
export const getUserDetail = data => http.get('/cms/User/' + data.uuid);
//禁用/启用用户
export const UserDisabled = data => http.put('/cms/UserDisabled/' + data.uuid, data);
//批量上传
export const UserImport = data => http.post('/cms/UserImport', data);
//编辑用户
export const addUserMember = data => http.put('/cms/User/' + data.user_uuid, data);


//会员配置列表
export const getMemberList = data => http.get('/cms/Member', data);
// 新会员配置
export const addMember = data => http.post('/cms/Member', data);
//编会员配置
export const updateMember = data => http.put('/cms/Member/' + data.uuid, data);
//会员配置详情
export const getMemberDetail = data => http.get('/cms/Member/' + data.uuid);
//删会员配置
export const deleteMember = data => http.delete('/cms/Member/' + data.uuid);


// 常见问题列表
export const getProblemList = data => http.get('/cms/Problem', data);
// 新增常见问题
export const addProblem = data => http.post('/cms/Problem', data);
//编辑常见问题
export const updateProblem = data => http.put('/cms/Problem/' + data.uuid, data);
//常见问题详情
export const getProblemDetail = data => http.get('/cms/Problem/' + data.uuid);
//删除常见问题
export const deleteProblem = data => http.delete('/cms/Problem/' + data.uuid);

//拉新情况
export const getInvite = data => http.get('/cms/Invite', data);